import { uploadFilesGetLinks } from "../files";
import { API, authClient } from "../index";

export const postOwner = async (owner, images, files) => {
  if (images && images?.length) {
    let imagesURLs = await uploadFilesGetLinks(images, "owners");
    owner.imagesURLs = (owner.imagesURLs || []).concat(imagesURLs);
  }
  if (files && files?.length) {
    let filesURLs = await uploadFilesGetLinks(files, "owners");
    owner.filesURLs = (owner.filesURLs || []).concat(filesURLs);
  }
  for (const artworkDesire of owner?.artworkDesires) {
    if (artworkDesire.images && artworkDesire.images?.length) {
      let imagesURLs = await uploadFilesGetLinks(
        artworkDesire.images,
        "artworkDesires"
      );
      artworkDesire.imagesURLs = imagesURLs;
    }
    if (artworkDesire.files && artworkDesire.files?.length) {
      let filesURLs = await uploadFilesGetLinks(
        artworkDesire.files,
        "artworkDesires"
      );
      artworkDesire.filesURLs = filesURLs;
    }
  }
  return authClient().post(`${API}/owner`, owner);
};

export const getOwners = () => {
  return authClient().get(`${API}/owner`);
};

export const getOwnerById = (id) => {
  return authClient().get(`${API}/owner/${id}`);
};

export const updateOwner = async (id, owner, images, files) => {
  if (images && images?.length) {
    let imagesURLs = await uploadFilesGetLinks(images, "owners");
    owner.imagesURLs = (owner.imagesURLs || []).concat(imagesURLs);
  }
  if (files && files?.length) {
    let filesURLs = await uploadFilesGetLinks(files, "owners");
    owner.filesURLs = (owner.filesURLs || []).concat(filesURLs);
  }
  for (const artworkDesire of owner?.artworkDesires) {
    if (artworkDesire.images && artworkDesire.images?.length) {
      let imagesURLs = await uploadFilesGetLinks(
        artworkDesire.images,
        "artworkDesires"
      );
      artworkDesire.imagesURLs = (artworkDesire.imagesURLs || []).concat(
        imagesURLs
      );
    }
    if (artworkDesire.files && artworkDesire.files?.length) {
      let filesURLs = await uploadFilesGetLinks(
        artworkDesire.files,
        "artworkDesires"
      );

      artworkDesire.filesURLs = (artworkDesire.filesURLs || []).concat(
        filesURLs
      );
    }
  }
  return authClient().put(`${API}/owner/${id}`, owner);
};

export const deleteOwner = (id) => {
  return authClient().delete(`${API}/owner/${id}`);
};
